import { SOURCE_SYNC_FIELD } from "constants/invoiceSourceSync";
import { InvoiceSourceSync } from "types/Models/invoiceSourceSync";

// The provider no longer has this invoice
export const isSourceDeleted = (sourceSync: InvoiceSourceSync): boolean =>
  sourceSync.changes.some(
    (change) => change.field === SOURCE_SYNC_FIELD.DELETED
  );
